<mw-form-section-title
  [title]="title"
  *ngIf="title"
  [isToggleDisabled]="isToggleDisabled"
  [hasToggle]="hasToggle"
  [isHideContent]="isHideContent"
  [foldable]="foldable"
  (hideContent)="hideContent($event)"
></mw-form-section-title>

<ng-container
  [ngTemplateOutlet]="templateRef"
  *ngIf="!isHideContent"
></ng-container>

<ng-template #content><ng-content></ng-content></ng-template>
